import { useQuery } from '@tanstack/react-query';
import { TProfileSecurityResponse } from '../api/types';
import { PROFILE_SECURITY_API_CACHE_KEY } from './types';
import { profileSecurity } from '../api';

export const useProfileSecurity = () => {
  return useQuery<TProfileSecurityResponse>({
    queryKey: [PROFILE_SECURITY_API_CACHE_KEY],
    queryFn: () => profileSecurity(),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });
};
